import { Flame } from 'lucide-react';
import { cn } from '@/lib/utils';

const sizeMap = {
  sm: 'w-5 h-5',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
} as const;

interface SpinnerProps {
  size?: keyof typeof sizeMap;
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div className={cn('relative inline-flex items-center justify-center', className)}>
      {/* Outline flame (always visible) */}
      <Flame
        className={cn(
          'text-primary/30 animate-flame-flicker',
          sizeMap[size],
        )}
      />
      {/* Filling flame overlay — clips from bottom to top */}
      <Flame
        fill="currentColor"
        strokeWidth={0}
        className={cn(
          'absolute inset-0 m-auto text-primary animate-flame-fill',
          sizeMap[size],
        )}
      />
    </div>
  );
}
